import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    minWidth: "100%",
    width: "100%",
  },
  wrapper: {
    margin: 10,
    fontSize: "9px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  column: {
    width: "45%",
  },
  productText: {
    fontSize: "12px",
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 10,
  },
  designIdColor: {
    color: "red",
  },
  level1Spacing: {
    marginTop: 4,
  },
  dataKey: {
    fontWeight: 600,
    marginTop: "10px"
  },
  level2Spacing: {
    marginTop: 4,
    marginLeft: 16,
  },
  level3pacing: {
    marginTop: 4,
    marginLeft: 32,
  },
});

export default styles;
